export function formatRange (data, formatter) {
  formatter = formatter || ((d) => `${d}`)

  if (Array.isArray(data)) {
    return `${formatter(data[0])} - ${formatter(data[1])}`
  } else {
    return formatter(data)
  }
}

export function roundTo (x, r, digits) {
  // determine number of decimal places from rounding precision value
  digits = digits || -Math.floor(Math.log10(r))
  if (digits < 0) { digits = 0 }

  return (r * Math.round(x / r)).toFixed(digits)
}

const FRACTIONS = {
  // '.0': '',
  // '.2': '⅕',
  // '.4': '⅖',
  // '.6': '⅗',
  // '.8': '⅘'
  '.00': '',
  '.25': '¼',
  '.50': '½',
  '.75': '¾'
}

export function formatFraction (v) {
  let digits = 2
  let s = roundTo(v, 0.25, 2)
  let decimal = s.substr(-(digits + 1))
  let rest = s.substr(0, s.length - (digits + 1))

  if (rest !== '0') {
    return `${rest}${FRACTIONS[decimal]}`
  } else {
    return FRACTIONS[decimal]
  }
}
